import List from './List/listProductClass';
import Add from './Add/addProductClass';
import View from './View/viewProductClass';
import Edit from './Edit/editProductClass';
export default { List, Add, View, Edit };
